import {
  FacebookShareButton, WhatsappShareButton, TwitterShareButton, TelegramShareButton,
  FacebookIcon, WhatsappIcon, TwitterIcon, TelegramIcon,
} from "react-share";
import { toast } from "sonner";
import { Link as LinkIcon } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ShareBar({ url, title, slug }) {
  // For rich previews (WhatsApp/FB/Twitter), share the backend /api/share/<slug>
  // page which serves Open Graph meta tags and redirects real users to the article.
  const shareUrl = slug ? `${BACKEND_URL}/api/share/${slug}` : url;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("లింక్ కాపీ చేయబడింది");
    } catch {
      toast.error("కాపీ విఫలం");
    }
  };
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="share-bar">
      <span className="font-body-te text-sm text-[#4A4A4A] mr-1">షేర్ చేయండి:</span>
      <WhatsappShareButton url={shareUrl} title={title} data-testid="share-whatsapp">
        <WhatsappIcon size={32} round />
      </WhatsappShareButton>
      <FacebookShareButton url={shareUrl} data-testid="share-facebook">
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      <TwitterShareButton url={shareUrl} title={title} data-testid="share-twitter">
        <TwitterIcon size={32} round />
      </TwitterShareButton>
      <TelegramShareButton url={shareUrl} title={title} data-testid="share-telegram">
        <TelegramIcon size={32} round />
      </TelegramShareButton>
      <button
        onClick={copy}
        className="w-8 h-8 rounded-full bg-[#2E7D32] text-white flex items-center justify-center hover:bg-[#1B5E20]"
        title="Copy link"
        data-testid="share-copy"
      >
        <LinkIcon className="w-4 h-4" />
      </button>
    </div>
  );
}
